import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 0,
    minutes: 45,
    seconds: 12
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="grid grid-cols-3 gap-3 max-w-sm mx-auto" data-id="element-52">
      {[{
      label: 'Ore',
      value: pad(time.hours)
    }, {
      label: 'Minuti',
      value: pad(time.minutes)
    }, {
      label: 'Secondi',
      value: pad(time.seconds)
    }].map((unit, idx) => <div key={idx} className="bg-volley-paper border border-volley-navy/10 text-volley-dark rounded-xl py-3 px-2 text-center shadow-sm" data-id="element-53">
          <div className="font-display text-3xl sm:text-4xl font-semibold text-volley-navy leading-none" data-id="element-54">
            {unit.value}
          </div>
          <div className="text-[10px] sm:text-xs uppercase tracking-wider text-volley-slate font-medium mt-1.5" data-id="element-55">
            {unit.label}
          </div>
        </div>)}
    </div>;
}